module.exports = __webpack_public_path__ + "static/img/18pic.7510d35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/18pic.png
// module id = Cb8q
// module chunks = 0